exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-6975a33c]{width:80%;margin-left:10%;margin-top:5%}h1[data-v-6975a33c]{text-align:center}p[data-v-6975a33c]{text-align:justify}.cta[data-v-6975a33c]{width:300px;margin:auto}.cta a[data-v-6975a33c]{margin:10px;text-decoration:none;display:inline-block;border:1px solid #521751;border-radius:3px;width:100px;padding:10px;box-sizing:border-box;color:#521751}.cta a[data-v-6975a33c]:active,.cta a[data-v-6975a33c]:hover{background-color:#521751;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6975a33c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/navigate/inicio.vue
// module id = 355
// module chunks = 0